/* eslint-disable no-extend-native -- deliberate: one documented, tested default
   (Mountain Time) for every Date display call in a single-time-zone business.
   See the header below and server/scripts/qa/mountaintime.test.js. */
/**
 * Mountain Time by default for every date shown (Pack C2, 2026-09-24).
 *
 * Thomas: "ensure all times are displayed as mountain time." The server runs in
 * UTC (measured: Railway 12:50 vs app log 18:50) and 116 of 123 date-formatting
 * calls named no time zone, so emails and reports printed UTC — anything after
 * ~6 PM Mountain showed as the next day. Browsers used the viewer's zone.
 *
 * Installed ONCE, first thing, in server/server.js and client/src/index.js.
 * It changes only the DEFAULT of Date#toLocaleDateString / toLocaleString /
 * toLocaleTimeString — a call that passes its own `timeZone` keeps it, and
 * Number#toLocaleString (money) is a different method and is untouched.
 *
 * The calendar-day rule (from utils/leadCsv.js, lesson in leadexport.test.js):
 * a value at exactly 00:00:00.000 UTC is a date the user picked
 * (<input type="date"> → UTC midnight). Converting it to Denver would show the
 * PREVIOUS day, so it renders in UTC — i.e. the stored day, verbatim.
 * Appointment dates are stored at 12:00 UTC, which is the same day in Denver.
 *
 * mountaintime.test.js proves every case against the server copy and checks
 * this file is the same code. Imported FIRST in client/src/index.js.
 */
export const TZ = 'America/Denver';

export function isCalendarDay(d) {
  return d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0 && d.getUTCMilliseconds() === 0;
}

export function install() {
  if (Date.prototype.__urpMountainTime) return false;
  const wrap = (name, dayAware) => {
    const original = Date.prototype[name];
    Object.defineProperty(Date.prototype, name, {
      configurable: true,
      writable: true,
      value: function (locales, options) {
        if (isNaN(this.getTime()) || (options && options.timeZone)) return original.call(this, locales, options);
        const timeZone = dayAware && isCalendarDay(this) ? 'UTC' : TZ;
        return original.call(this, locales, { ...(options || {}), timeZone });
      }
    });
  };
  wrap('toLocaleDateString', true);
  wrap('toLocaleString', true);
  wrap('toLocaleTimeString', false);
  Object.defineProperty(Date.prototype, '__urpMountainTime', { value: true });
  return true;
}

install();

